import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["content"]

import { computed } from "vue";
import i18n from "@/plugins/vue-i18n";

interface Props {
  type: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VType',
  props: {
    type: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const symbol = computed(() => {
  let value = "";
  let [typeFirstSymbol] = props.type.toUpperCase();

  switch (props.type) {
    case "push":
      value = "PN";
      break;
    case "pop":
      value = "PP";
      break;
    default:
      value = typeFirstSymbol;
  }

  return value;
});
const tippyConfig = computed(() => ({ onShow: () => !!symbol.value }));
const tooltip = computed(() => i18n.t(`creative.type.${props.type}`));

return (_ctx: any,_cache: any) => {
  const _directive_tippy = _resolveDirective("tippy")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    content: tooltip.value,
    class: "type"
  }, [
    _createTextVNode(_toDisplayString(symbol.value), 1)
  ], 8, _hoisted_1)), [
    [_directive_tippy, tippyConfig.value]
  ])
}
}

})